import { render } from "./SimpleHeader.vue?vue&type=template&id=558be438&scoped=true"
import script from "./SimpleHeader.vue?vue&type=script&lang=js"
export * from "./SimpleHeader.vue?vue&type=script&lang=js"

import "./SimpleHeader.vue?vue&type=style&index=0&id=558be438&scoped=true&lang=css"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558be438"]])

export default __exports__